<template>
  <el-dialog
    :visible="limitModal.visible"
    :show-close="false"
    custom-class="plm-dialog"
    width="540px"
    @close="close"
  >
    <div class="plm-modal" v-if="limitModal.visible">
      <!-- Hero -->
      <div class="plm-hero" :class="variant">
        <div class="plm-hero-top">
          <Logo color="white" width="110" />
          <button class="plm-close" @click="close">
            <svg width="11" height="11" viewBox="0 0 11 11" fill="none">
              <path
                d="M1 1l9 9M10 1L1 10"
                stroke="rgba(255,255,255,.7)"
                stroke-width="1.8"
                stroke-linecap="round"
              />
            </svg>
          </button>
        </div>

        <div class="plm-limit-indicator">
          <div class="plm-icon-wrap">
            <!-- docs -->
            <svg
              v-if="variant === 'docs'"
              width="26"
              height="26"
              viewBox="0 0 26 26"
              fill="none"
            >
              <rect
                x="5"
                y="3"
                width="14"
                height="18"
                rx="2"
                fill="rgba(255,255,255,.08)"
                stroke="rgba(255,255,255,.4)"
                stroke-width="1.4"
              />
              <path
                d="M9 8h8M9 12h8M9 16h5"
                stroke="rgba(255,255,255,.35)"
                stroke-width="1.3"
                stroke-linecap="round"
              />
              <circle cx="20" cy="20" r="5" fill="#e24b4a" />
              <path
                d="M18.5 20h3M20 18.5v3"
                stroke="#fff"
                stroke-width="1.5"
                stroke-linecap="round"
                transform="rotate(45 20 20)"
              />
            </svg>
            <!-- ai -->
            <svg
              v-else-if="variant === 'ai'"
              width="26"
              height="26"
              viewBox="0 0 26 26"
              fill="none"
            >
              <circle
                cx="13"
                cy="13"
                r="7"
                fill="rgba(255,255,255,.08)"
                stroke="rgba(255,255,255,.4)"
                stroke-width="1.4"
              />
              <path
                d="M10 13.5L12 15.5L16 10.5"
                stroke="rgba(255,255,255,.4)"
                stroke-width="1.4"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M13 6V8M13 18V20M6 13H8M18 13H20"
                stroke="rgba(255,255,255,.35)"
                stroke-width="1.3"
                stroke-linecap="round"
              />
              <circle cx="20" cy="20" r="5" fill="#e24b4a" />
              <path
                d="M18.5 20h3M20 18.5v3"
                stroke="#fff"
                stroke-width="1.5"
                stroke-linecap="round"
                transform="rotate(45 20 20)"
              />
            </svg>
            <!-- sign -->
            <svg
              v-else-if="variant === 'sign'"
              width="26"
              height="26"
              viewBox="0 0 26 26"
              fill="none"
            >
              <rect
                x="5"
                y="3"
                width="14"
                height="18"
                rx="2"
                fill="rgba(255,255,255,.08)"
                stroke="rgba(255,255,255,.4)"
                stroke-width="1.4"
              />
              <path
                d="M9 8h8M9 12h8M9 16h4"
                stroke="rgba(255,255,255,.35)"
                stroke-width="1.3"
                stroke-linecap="round"
              />
              <path
                d="M14 16.5c1-1.5 3-1 3 .5s-2 2-3 .5"
                stroke="rgba(255,255,255,.5)"
                stroke-width="1.2"
                stroke-linecap="round"
              />
              <circle cx="20" cy="20" r="5" fill="#e24b4a" />
              <path
                d="M18.5 20h3M20 18.5v3"
                stroke="#fff"
                stroke-width="1.5"
                stroke-linecap="round"
                transform="rotate(45 20 20)"
              />
            </svg>
            <!-- bulk -->
            <svg
              v-else-if="variant === 'bulk'"
              width="26"
              height="26"
              viewBox="0 0 26 26"
              fill="none"
            >
              <path
                d="M4 8l9 6 9-6"
                stroke="rgba(255,255,255,.4)"
                stroke-width="1.4"
                stroke-linecap="round"
              />
              <rect
                x="4"
                y="6"
                width="18"
                height="14"
                rx="2"
                fill="rgba(255,255,255,.08)"
                stroke="rgba(255,255,255,.4)"
                stroke-width="1.4"
              />
              <circle cx="20" cy="20" r="5" fill="#e24b4a" />
              <path
                d="M18.5 20h3M20 18.5v3"
                stroke="#fff"
                stroke-width="1.5"
                stroke-linecap="round"
                transform="rotate(45 20 20)"
              />
            </svg>
            <!-- legacy -->
            <svg v-else width="26" height="26" viewBox="0 0 26 26" fill="none">
              <circle
                cx="13"
                cy="13"
                r="8"
                fill="rgba(255,255,255,.07)"
                stroke="rgba(255,255,255,.35)"
                stroke-width="1.4"
              />
              <path
                d="M13 8v5l3 3"
                stroke="rgba(255,255,255,.55)"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>

          <div class="plm-text-wrap">
            <div
              class="plm-tag"
              :class="
                variant === 'legacy' || isWarning ? 'tag-legacy' : 'tag-limit'
              "
            >
              <span
                class="plm-tag-dot"
                :class="
                  variant === 'legacy' || isWarning ? 'dot-amber' : 'dot-red'
                "
              ></span>
              <span>{{ limitTag }}</span>
            </div>
            <div class="plm-hero-title" v-html="heroTitle"></div>
          </div>
        </div>

        <div class="plm-bar-wrap" v-if="variant !== 'legacy'">
          <div class="plm-bar-labels">
            <span>{{ featureLabel }}</span>
            <strong>{{ usageData.used }} / {{ usageData.limit }}</strong>
          </div>
          <div class="plm-bar-track">
            <div
              class="plm-bar-fill"
              :class="[variant, { warning: isWarning }]"
              :style="{ width: barWidth + '%' }"
            ></div>
          </div>
        </div>
        <div class="plm-bar-wrap" v-else>
          <div class="plm-bar-labels">
            <span>Plan activo hasta</span>
            <strong>{{ planExpiresAt }}</strong>
          </div>
          <div class="plm-bar-track">
            <div class="plm-bar-fill legacy" style="width: 85%"></div>
          </div>
        </div>
      </div>

      <!-- Body -->
      <div class="plm-body">
        <!-- Legacy variant -->
        <template v-if="variant === 'legacy'">
          <div class="plm-legacy-box">
            <div class="plm-legacy-ico">
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                <path
                  d="M9 2l1.8 3.6L15 6.5l-3 2.9.7 4.1L9 11.5l-3.7 1.9.7-4.1L3 6.5l4.2-.9L9 2z"
                  fill="url(#plm-star-g)"
                />
                <defs>
                  <linearGradient
                    id="plm-star-g"
                    x1="3"
                    y1="2"
                    x2="15"
                    y2="13.5"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#534ab7" />
                    <stop offset="1" stop-color="#3ecfb4" />
                  </linearGradient>
                </defs>
              </svg>
            </div>
            <div class="plm-legacy-body">
              <div class="plm-legacy-title">
                Tu plan actual seguirá activo hasta su vencimiento
              </div>
              <div class="plm-legacy-desc">
                Al renovar, elige uno de los nuevos planes y accede a IA,
                dashboard inteligente, firma electrónica y mucho más. No
                perderás tu historial ni tus datos.
              </div>
            </div>
          </div>
          <div class="plm-cta-row">
            <button class="plm-btn-primary" @click="goToPlans">
              Ver todos los planes
              <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
                <path
                  d="M2 6.5h9M7.5 3l3 3.5-3 3"
                  stroke="#fff"
                  stroke-width="1.6"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
            <button class="plm-btn-ghost" @click="close">
              Recordarme más tarde
            </button>
          </div>
        </template>

        <!-- Highest plan reached (no upgrade available) -->
        <template v-else-if="!nextPlan">
          <div class="plm-top-plan-msg">
            <div class="plm-top-plan-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                  d="M12 2l2.4 4.8L20 8l-4 3.9.9 5.5L12 15l-4.9 2.5.9-5.5L4 8l5.6-1.2L12 2z"
                  fill="url(#plm-star2)"
                />
                <defs>
                  <linearGradient
                    id="plm-star2"
                    x1="4"
                    y1="2"
                    x2="20"
                    y2="17"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#534ab7" />
                    <stop offset="1" stop-color="#3ecfb4" />
                  </linearGradient>
                </defs>
              </svg>
            </div>
            <p class="plm-notice" v-if="docsNotice">{{ docsNotice }}</p>
            <p class="plm-top-plan-text">
              Ya tienes el plan más completo. Para necesitar más capacidad,
              <a href="mailto:hola@mydessk.com">contacta a nuestro equipo</a>.
            </p>
          </div>
          <div class="plm-cta-row">
            <button class="plm-btn-ghost full" @click="close">Continuar</button>
          </div>
        </template>

        <!-- New plan with upgrade available -->
        <template v-else>
          <p class="plm-notice" v-if="docsNotice">{{ docsNotice }}</p>
          <div class="plm-body-title">{{ upgradeTitle }}</div>

          <div class="plm-next-plan-card" :class="{ featured: true }">
            <div class="plm-plan-badge">Recomendado</div>
            <div class="plm-plan-name">
              {{ nextPlan.display_name || nextPlan.name }}
            </div>
            <div class="plm-plan-price">
              <span class="plm-plan-currency">$</span>
              <span class="plm-plan-amount">{{ nextPlanPrice }}</span>
              <span class="plm-plan-period">/mes</span>
            </div>
            <div class="plm-plan-desc">{{ nextPlanFeatureDesc }}</div>
          </div>

          <div class="plm-unlocks">
            <div
              class="plm-unlock-row"
              v-for="(bullet, i) in benefitBullets"
              :key="i"
            >
              <div class="plm-unlock-ico" :class="bulletColors[i]">
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                  <path
                    d="M2 7l3.5 3.5L12 3"
                    :stroke="bulletStrokes[i]"
                    stroke-width="1.6"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <div class="plm-unlock-text" v-html="bullet"></div>
            </div>
          </div>

          <div class="plm-cta-row">
            <button class="plm-btn-primary" @click="goToPlans">
              {{ ctaLabel }}
              <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
                <path
                  d="M2 6.5h9M7.5 3l3 3.5-3 3"
                  stroke="#fff"
                  stroke-width="1.6"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
            <button class="plm-btn-ghost" @click="close">
              {{ dismissLabel }}
            </button>
          </div>
        </template>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Logo from "@/components/Logo/Logo";

const VARIANT_MAP = {
  documents_monthly_limit: "docs",
  ai_credits_monthly: "ai",
  document_signing_monthly_limit: "sign",
  bulk_sending: "bulk"
};

export default {
  name: "PlanLimitModal",
  components: { Logo },
  computed: {
    ...mapGetters([
      "limitModal",
      "isLegacyPlan",
      "nextUpgradePlan",
      "usageByFeature",
      "userPlan"
    ]),

    variant() {
      if (this.isLegacyPlan) return "legacy";
      return VARIANT_MAP[this.limitModal.feature] || "docs";
    },
    isWarning() {
      return this.limitModal.warning === true;
    },
    // "1 de noviembre": el cupo de documentos se renueva el primer día del mes
    resetDate() {
      const d = new Date();
      const next = new Date(d.getFullYear(), d.getMonth() + 1, 1);
      return `1 de ${next.toLocaleDateString("es-EC", { month: "long" })}`;
    },
    docsNotice() {
      if (this.variant !== "docs" || !this.usageData?.limit) return "";
      if (this.isWarning) {
        return `Al llegar a ${this.usageData.limit} documentos no podrás emitir comprobantes en producción hasta el ${this.resetDate}. Puedes seguir con tu plan actual o mejorarlo cuando quieras.`;
      }
      return `No podrás emitir comprobantes en producción hasta el ${this.resetDate}, cuando se renueva tu cupo. Puedes seguir con tu plan actual o mejorarlo para emitir desde ahora.`;
    },

    usageData() {
      const stored = this.limitModal.usage;
      if (stored && stored.limit != null) return stored;
      return this.usageByFeature(this.limitModal.feature);
    },

    barWidth() {
      if (!this.usageData || !this.usageData.limit) return 100;
      return Math.min(
        Math.round((this.usageData.used / this.usageData.limit) * 100),
        100
      );
    },

    nextPlan() {
      return this.nextUpgradePlan(this.limitModal.feature);
    },

    nextPlanPrice() {
      if (!this.nextPlan) return "–";
      const pricing = this.nextPlan.pricing;
      if (pricing?.monthly?.effective_price != null)
        return Math.round(pricing.monthly.effective_price);
      if (this.nextPlan.price != null) return Math.round(this.nextPlan.price);
      return "–";
    },

    nextPlanFeatureDesc() {
      if (!this.nextPlan) return "";
      const feat = this.nextPlan.features?.find
        ? this.nextPlan.features.find(f => f.slug === this.limitModal.feature)
        : null;
      if (!feat) return "";
      if (feat.value === "unlimited") return "Ilimitado";
      const labels = {
        documents_monthly_limit: `${feat.value} docs / mes`,
        ai_credits_monthly: `${feat.value} créditos IA / mes`,
        document_signing_monthly_limit: `${feat.value} firmas / mes`,
        bulk_sending: `${feat.value} envíos masivos / mes`
      };
      return labels[this.limitModal.feature] || feat.value;
    },

    planExpiresAt() {
      return this.userPlan?.plan?.expires_at || "";
    },

    limitTag() {
      if (this.isWarning) return "Aviso de tu plan";
      const tags = {
        docs: "Documentos agotados",
        ai: "Créditos agotados",
        sign: "Firmas agotadas",
        bulk: "Envíos agotados",
        legacy: "Plan legacy"
      };
      return tags[this.variant] || "Límite alcanzado";
    },

    heroTitle() {
      if (this.isWarning && this.usageData?.limit) {
        const left = Math.max(0, this.usageData.limit - this.usageData.used);
        return `Te quedan <em>${left} documento${
          left === 1 ? "" : "s"
        }</em><br/>este mes.`;
      }
      const titles = {
        docs: "Alcanzaste el límite<br/>de <em>documentos</em> del mes.",
        ai: "Tu IA se quedó<br/>sin <em>créditos</em> este mes.",
        sign: "Usaste tu firma<br/><em>electrónica</em> del mes.",
        bulk: "Alcanzaste el límite<br/>de <em>envíos masivos</em>.",
        legacy: "Tu plan anterior<br/>llega a su <em>fin.</em>"
      };
      return titles[this.variant] || "Límite de plan <em>alcanzado.</em>";
    },

    featureLabel() {
      const labels = {
        docs: "Documentos utilizados",
        ai: "Créditos IA utilizados",
        sign: "Firmas utilizadas",
        bulk: "Envíos masivos utilizados"
      };
      return labels[this.variant] || "Uso actual";
    },

    upgradeTitle() {
      const titles = {
        docs: "Desbloquea más documentos para tu negocio",
        ai: "Desbloquea más inteligencia para tu negocio",
        sign: "Desbloquea más firmas para seguir cerrando contratos",
        bulk: "Desbloquea más envíos masivos para llegar a tus clientes"
      };
      return titles[this.variant] || "Mejora tu plan para continuar";
    },

    benefitBullets() {
      const bullets = {
        docs: [
          "<strong>Más documentos al mes</strong>: facturas, notas de crédito, retenciones y guías de remisión",
          "<strong>Envíos automáticos al SRI</strong> con validación en tiempo real",
          "<strong>Historial completo</strong> y exportación de reportes sin restricción"
        ],
        ai: [
          "<strong>Más créditos IA al mes</strong>: copiloto, asistente de cotizaciones y redactor de emails",
          "<strong>Respuestas más rápidas</strong> con modelo avanzado para análisis de negocio complejos",
          "<strong>Historial de conversaciones</strong> guardado para no perder contexto entre sesiones"
        ],
        sign: [
          "<strong>Más firmas electrónicas al mes</strong>: válidas bajo la Ley 67 de Ecuador",
          "<strong>Seguimiento en tiempo real</strong>: sabe cuándo tu cliente abrió y firmó el documento",
          "<strong>Log de auditoría descargable</strong> con IP, timestamp y hash SHA-256"
        ],
        bulk: [
          "<strong>Más envíos masivos al mes</strong>: notificaciones, recordatorios y cobranzas",
          "<strong>Segmentación de clientes</strong> para campañas más efectivas",
          "<strong>Reportes de apertura</strong> y seguimiento de respuesta por cliente"
        ]
      };
      return bullets[this.variant] || [];
    },

    bulletColors() {
      return ["purple", "teal", "amber"];
    },

    bulletStrokes() {
      return ["#534ab7", "#1d9e75", "#ba7517"];
    },

    ctaLabel() {
      if (this.isWarning) return "Mejorar mi plan";
      const labels = {
        docs: "Ver planes con más documentos",
        ai: "Ver planes con más IA",
        sign: "Desbloquear más firmas",
        bulk: "Ver planes con más envíos"
      };
      return labels[this.variant] || "Ver planes";
    },

    dismissLabel() {
      const labels = {
        docs: "Seguir con mi plan",
        ai: "Continuar sin IA",
        sign: "Seguir en mi plan actual",
        bulk: "Continuar sin envíos masivos"
      };
      return labels[this.variant] || "Continuar";
    }
  },
  methods: {
    ...mapActions(["hideLimitModal"]),
    close() {
      this.hideLimitModal();
    },
    goToPlans() {
      this.hideLimitModal();
      this.$router.push("/dashboard/planes");
    }
  }
};
</script>

<style lang="scss">
.plm-dialog {
  border-radius: 20px !important;
  overflow: hidden;
  padding: 0 !important;

  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 0;
  }
}
</style>

<style lang="scss" scoped>
$navy: #1e1c42;
$navy-mid: #2a2752;
$teal: #3ecfb4;
$teal-dark: #1d9e75;
$purple: #534ab7;
$amber: #ba7517;
$red: #e24b4a;
$border: #eae9e5;
$text: #1e1c42;
$text-muted: #888;

@keyframes fadeUp {
  from {
    opacity: 0;
    transform: translateY(16px) scale(0.97);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@keyframes fillBar {
  from {
    width: 0 !important;
  }
  to {
    width: var(--bar-target);
  }
}

.plm-modal {
  // el-dialog__body trae word-break: break-all y parte las palabras
  word-break: normal;
  overflow-wrap: break-word;
  animation: fadeUp 0.3s cubic-bezier(0.22, 1, 0.36, 1) both;
  font-family: "Plus Jakarta Sans", "DM Sans", -apple-system, sans-serif;
}

/* ── Hero ── */
.plm-hero {
  padding: 24px 24px 20px;
  position: relative;
  overflow: hidden;

  &::after {
    content: "";
    position: absolute;
    top: -40px;
    right: -40px;
    width: 180px;
    height: 180px;
    border-radius: 50%;
    background: radial-gradient(
      circle,
      rgba(255, 255, 255, 0.07) 0%,
      transparent 70%
    );
    pointer-events: none;
  }

  &.docs {
    background: linear-gradient(135deg, $navy 0%, $navy-mid 100%);
  }
  &.ai {
    background: linear-gradient(135deg, #2a1e52 0%, #1e3a42 100%);
  }
  &.sign {
    background: linear-gradient(135deg, $navy 0%, #3a2818 100%);
  }
  &.bulk {
    background: linear-gradient(135deg, $navy 0%, #1a3030 100%);
  }
  &.legacy {
    background: linear-gradient(135deg, $navy 0%, #1a2e42 100%);
  }
}

.plm-hero-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 18px;
  position: relative;
  z-index: 1;
}

.plm-close {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 1.5px solid rgba(255, 255, 255, 0.2);
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s;
  flex-shrink: 0;
  &:hover {
    background: rgba(255, 255, 255, 0.12);
  }
}

.plm-limit-indicator {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 16px;
  position: relative;
  z-index: 1;
}

.plm-icon-wrap {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.12);
}

.plm-text-wrap {
  flex: 1;
}

.plm-tag {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  border-radius: 20px;
  padding: 3px 10px;
  margin-bottom: 6px;

  &.tag-limit {
    background: rgba(226, 75, 74, 0.2);
    border: 1px solid rgba(226, 75, 74, 0.35);
    span:last-child {
      font-size: 10px;
      font-weight: 700;
      color: #ff8a88;
      letter-spacing: 0.5px;
      text-transform: uppercase;
    }
  }
  &.tag-legacy {
    background: rgba(186, 117, 23, 0.2);
    border: 1px solid rgba(186, 117, 23, 0.35);
    span:last-child {
      font-size: 10px;
      font-weight: 700;
      color: #fbbf60;
      letter-spacing: 0.5px;
      text-transform: uppercase;
    }
  }
}

.plm-tag-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
  &.dot-red {
    background: #ff8a88;
  }
  &.dot-amber {
    background: #fbbf60;
  }
}

.plm-hero-title {
  font-size: 19px;
  font-weight: 700;
  color: #fff;
  line-height: 1.25;
  letter-spacing: -0.3px;

  ::v-deep em {
    font-style: normal;
    color: $teal;
  }
}

/* Bar */
.plm-bar-wrap {
  position: relative;
  z-index: 1;
}

.plm-bar-labels {
  display: flex;
  justify-content: space-between;
  margin-bottom: 6px;
  span {
    font-size: 11px;
    color: rgba(255, 255, 255, 0.5);
  }
  strong {
    font-size: 11px;
    color: rgba(255, 255, 255, 0.9);
    font-weight: 600;
  }
}

.plm-bar-track {
  height: 6px;
  background: rgba(255, 255, 255, 0.12);
  border-radius: 10px;
  overflow: hidden;
}

.plm-bar-fill {
  height: 100%;
  border-radius: 10px;
  transition: width 0.6s cubic-bezier(0.22, 1, 0.36, 1);
  &.docs,
  &.ai,
  &.sign,
  &.bulk {
    background: linear-gradient(90deg, $red, #ff6b6b);
  }
  &.legacy,
  &.warning {
    background: linear-gradient(90deg, $amber, #fbbf60);
  }
}

.plm-notice {
  font-size: 13px;
  line-height: 1.5;
  color: $text-muted;
  margin: 0 0 16px;
}

/* ── Body ── */
.plm-body {
  padding: 20px 24px 24px;
}

.plm-body-title {
  font-size: 13px;
  font-weight: 600;
  color: $text;
  margin-bottom: 14px;
}

/* Next plan card (single) */
.plm-next-plan-card {
  border: 1.5px solid $border;
  border-radius: 14px;
  padding: 18px 16px;
  text-align: center;
  position: relative;
  margin-bottom: 16px;
  cursor: default;

  &.featured {
    border-color: $teal;
    border-width: 2px;
    background: linear-gradient(to bottom, rgba(62, 207, 180, 0.03), #fff);
  }
}

.plm-plan-badge {
  position: absolute;
  top: -10px;
  left: 50%;
  transform: translateX(-50%);
  background: $teal;
  color: #fff;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.5px;
  padding: 3px 10px;
  border-radius: 20px;
  white-space: nowrap;
  text-transform: uppercase;
}

.plm-plan-name {
  font-size: 11px;
  font-weight: 600;
  color: $text-muted;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 6px;
}

.plm-plan-price {
  display: inline-flex;
  align-items: baseline;
  gap: 2px;
  color: $text;
  line-height: 1;
  margin-bottom: 6px;
}

.plm-plan-currency {
  font-size: 16px;
  font-weight: 600;
}

.plm-plan-amount {
  font-size: 28px;
  font-weight: 700;
}

.plm-plan-period {
  font-size: 11px;
  font-weight: 400;
  color: $text-muted;
}

.plm-plan-desc {
  font-size: 12px;
  color: $text-muted;
  line-height: 1.4;
}

/* Bullets */
.plm-unlocks {
  margin-bottom: 18px;
}

.plm-unlock-row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 9px;
  &:last-child {
    margin-bottom: 0;
  }
}

.plm-unlock-ico {
  width: 22px;
  height: 22px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  &.purple {
    background: #f0effe;
  }
  &.teal {
    background: #edfaf6;
  }
  &.amber {
    background: #fef6eb;
  }
}

.plm-unlock-text {
  font-size: 12px;
  color: $text-muted;
  line-height: 1.5;
  strong {
    color: $text;
    font-weight: 600;
  }
}

/* CTAs */
.plm-cta-row {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.plm-btn-primary {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 12px 20px;
  background: $navy;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  transition: background 0.18s, transform 0.1s;
  &:hover {
    background: darken($navy, 5%);
    transform: translateY(-1px);
  }
  &:active {
    transform: translateY(0);
  }
}

.plm-btn-ghost {
  width: 100%;
  padding: 11px 20px;
  background: transparent;
  color: $text-muted;
  font-size: 12px;
  font-weight: 500;
  border: 1.5px solid $border;
  border-radius: 10px;
  cursor: pointer;
  transition: border-color 0.15s, color 0.15s;
  &:hover {
    border-color: #ccc;
    color: $text;
  }
  &.full {
    border: none;
    color: $text-muted;
  }
}

/* Legacy box */
.plm-legacy-box {
  display: flex;
  gap: 12px;
  background: #f7f6f2;
  border: 1.5px solid $border;
  border-radius: 12px;
  padding: 14px;
  margin-bottom: 18px;
}

.plm-legacy-ico {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: #fff;
  border: 1px solid $border;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.plm-legacy-title {
  font-size: 12px;
  font-weight: 600;
  color: $text;
  margin-bottom: 4px;
}

.plm-legacy-desc {
  font-size: 11px;
  color: $text-muted;
  line-height: 1.5;
}

/* Top plan message */
.plm-top-plan-msg {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 16px 0 20px;
  gap: 10px;
}

.plm-top-plan-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: linear-gradient(135deg, #f0effe, #edfaf6);
  display: flex;
  align-items: center;
  justify-content: center;
}

.plm-top-plan-text {
  font-size: 13px;
  color: $text-muted;
  line-height: 1.6;
  max-width: 340px;
  a {
    color: $purple;
    text-decoration: none;
    font-weight: 500;
  }
}
</style>
